"use strict";
exports["31272aa1"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizPopTitleText","properties":{"popServer":{"type":"string","title":"LabelPopServer","pattern":"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"},"security":{"type":"string","title":"LabelSecurityType","default":"SSL","enum":["SSL","TLS"]},"userName":{"type":"string","title":"LabelDomainUser","pattern":"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},"password":{"type":"string","title":"LabelPassword"},"ignoreTrustForSsl":{"type":"boolean","title":"LabelIgnoreTrustForSsl","default":false},"notice":{"type":"object","title":"PanelTitle_Notice","properties":{"testAccountConsent":{"type":"boolean","title":"TestAccountConsent","description":"NoticeDescription"}},"required":["testAccountConsent"]},"proofOfWork":{"type":"string","title":""}},"required":["popServer","security","userName","password","notice","proofOfWork"],"dependencies":{"security":{"oneOf":[{"properties":{"security":{"enum":["SSL"]},"sslPort":{"type":"number","title":"LabelPopImapPort","default":995}},"required":["sslPort"]},{"properties":{"security":{"enum":["TLS"]},"tlsPort":{"type":"number","title":"LabelPopImapPort","default":110}},"required":["tlsPort"]}]}},"$id":"31272aa1"};
const pattern0 = new RegExp("^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$", "u");
const pattern1 = new RegExp("^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$", "u");

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="31272aa1" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.popServer === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "popServer"},message:"must have required property '"+"popServer"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.security === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "security"},message:"must have required property '"+"security"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.userName === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "userName"},message:"must have required property '"+"userName"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.password === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "password"},message:"must have required property '"+"password"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.notice === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "notice"},message:"must have required property '"+"notice"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.proofOfWork === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.security !== undefined){
const _errs2 = errors;
let valid1 = false;
let passing0 = null;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.sslPort === undefined){
const err6 = {instancePath,schemaPath:"#/dependencies/security/oneOf/0/required",keyword:"required",params:{missingProperty: "sslPort"},message:"must have required property '"+"sslPort"+"'",schema:schema11.dependencies.security.oneOf[0].required,parentSchema:schema11.dependencies.security.oneOf[0],data};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.security !== undefined){
let data0 = data.security;
if(!(data0 === "SSL")){
const err7 = {instancePath:instancePath+"/security",schemaPath:"#/dependencies/security/oneOf/0/properties/security/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.security.oneOf[0].properties.security.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.security.oneOf[0].properties.security.enum,parentSchema:schema11.dependencies.security.oneOf[0].properties.security,data:data0};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.sslPort !== undefined){
let data1 = data.sslPort;
if(!(typeof data1 == "number")){
const err8 = {instancePath:instancePath+"/sslPort",schemaPath:"#/dependencies/security/oneOf/0/properties/sslPort/type",keyword:"type",params:{type: "number"},message:"must be number",schema:schema11.dependencies.security.oneOf[0].properties.sslPort.type,parentSchema:schema11.dependencies.security.oneOf[0].properties.sslPort,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
var _valid0 = _errs3 === errors;
if(_valid0){
valid1 = true;
passing0 = 0;
}
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.tlsPort === undefined){
const err9 = {instancePath,schemaPath:"#/dependencies/security/oneOf/1/required",keyword:"required",params:{missingProperty: "tlsPort"},message:"must have required property '"+"tlsPort"+"'",schema:schema11.dependencies.security.oneOf[1].required,parentSchema:schema11.dependencies.security.oneOf[1],data};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.security !== undefined){
let data2 = data.security;
if(!(data2 === "TLS")){
const err10 = {instancePath:instancePath+"/security",schemaPath:"#/dependencies/security/oneOf/1/properties/security/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.security.oneOf[1].properties.security.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.security.oneOf[1].properties.security.enum,parentSchema:schema11.dependencies.security.oneOf[1].properties.security,data:data2};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.tlsPort !== undefined){
let data3 = data.tlsPort;
if(!(typeof data3 == "number")){
const err11 = {instancePath:instancePath+"/tlsPort",schemaPath:"#/dependencies/security/oneOf/1/properties/tlsPort/type",keyword:"type",params:{type: "number"},message:"must be number",schema:schema11.dependencies.security.oneOf[1].properties.tlsPort.type,parentSchema:schema11.dependencies.security.oneOf[1].properties.tlsPort,data:data3};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
var _valid0 = _errs7 === errors;
if(_valid0 && valid1){
valid1 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid1 = true;
passing0 = 1;
}
}
if(!valid1){
const err12 = {instancePath,schemaPath:"#/dependencies/security/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.security.oneOf,parentSchema:schema11.dependencies.security,data};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
else {
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
}
}
if(data.popServer !== undefined){
let data4 = data.popServer;
if(typeof data4 === "string"){
if(!pattern0.test(data4)){
const err13 = {instancePath:instancePath+"/popServer",schemaPath:"#/properties/popServer/pattern",keyword:"pattern",params:{pattern: "^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"},message:"must match pattern \""+"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$"+"\"",schema:"^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$",parentSchema:schema11.properties.popServer,data:data4};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/popServer",schemaPath:"#/properties/popServer/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.popServer.type,parentSchema:schema11.properties.popServer,data:data4};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.security !== undefined){
let data5 = data.security;
if(typeof data5 !== "string"){
const err15 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.security.type,parentSchema:schema11.properties.security,data:data5};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(!((data5 === "SSL") || (data5 === "TLS"))){
const err16 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/enum",keyword:"enum",params:{allowedValues: schema11.properties.security.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.security.enum,parentSchema:schema11.properties.security,data:data5};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.userName !== undefined){
let data6 = data.userName;
if(typeof data6 === "string"){
if(!pattern1.test(data6)){
const err17 = {instancePath:instancePath+"/userName",schemaPath:"#/properties/userName/pattern",keyword:"pattern",params:{pattern: "^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},message:"must match pattern \""+"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"+"\"",schema:"^.+\\\\.+$|^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$",parentSchema:schema11.properties.userName,data:data6};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/userName",schemaPath:"#/properties/userName/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.userName.type,parentSchema:schema11.properties.userName,data:data6};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.password !== undefined){
let data7 = data.password;
if(typeof data7 !== "string"){
const err19 = {instancePath:instancePath+"/password",schemaPath:"#/properties/password/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.password.type,parentSchema:schema11.properties.password,data:data7};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.ignoreTrustForSsl !== undefined){
let data8 = data.ignoreTrustForSsl;
if(typeof data8 !== "boolean"){
const err20 = {instancePath:instancePath+"/ignoreTrustForSsl",schemaPath:"#/properties/ignoreTrustForSsl/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.ignoreTrustForSsl.type,parentSchema:schema11.properties.ignoreTrustForSsl,data:data8};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.notice !== undefined){
let data9 = data.notice;
if(data9 && typeof data9 == "object" && !Array.isArray(data9)){
if(data9.testAccountConsent === undefined){
const err21 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/required",keyword:"required",params:{missingProperty: "testAccountConsent"},message:"must have required property '"+"testAccountConsent"+"'",schema:schema11.properties.notice.required,parentSchema:schema11.properties.notice,data:data9};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data9.testAccountConsent !== undefined){
let data10 = data9.testAccountConsent;
if(typeof data10 !== "boolean"){
const err22 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.notice.properties.testAccountConsent.type,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data10};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.notice.type,parentSchema:schema11.properties.notice,data:data9};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data11 = data.proofOfWork;
if(typeof data11 !== "string"){
const err24 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data11};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
else {
const err25 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}

exports["-5405303b"] = validate11;
const schema12 = {"type":"object","properties":{"security":{"enum":["SSL"]}},"$id":"-5405303b"};

function validate11(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-5405303b" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.security !== undefined){
let data0 = data.security;
if(!(data0 === "SSL")){
const err0 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/enum",keyword:"enum",params:{allowedValues: schema12.properties.security.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.security.enum,parentSchema:schema12.properties.security,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.type,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate11.errors = vErrors;
return errors === 0;
}

exports["4e494836"] = validate12;
const schema13 = {"type":"object","properties":{"security":{"enum":["TLS"]}},"$id":"4e494836"};

function validate12(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="4e494836" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.security !== undefined){
let data0 = data.security;
if(!(data0 === "TLS")){
const err0 = {instancePath:instancePath+"/security",schemaPath:"#/properties/security/enum",keyword:"enum",params:{allowedValues: schema13.properties.security.enum},message:"must be equal to one of the allowed values",schema:schema13.properties.security.enum,parentSchema:schema13.properties.security,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema13.type,parentSchema:schema13,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate12.errors = vErrors;
return errors === 0;
}
